export default __webpack_public_path__ + "static/media/goodFoodDiscounts.9b9dd889.png";